import { Route } from '@angular/router';

export const THEME_ENGINE_ROUTES: Route[] = [
    {
        path: '',
        loadComponent: () => import('./theme-engine.component').then((comp) => comp.ThemeEngineComponent)
    }
];
